import { Flex } from '@cognite/cogs-core';
import styled from 'styled-components';

export const MediaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
  width: 140px;
  background-color: var(--cogs-themed-surface--action--muted--default);
  border-radius: 6px;
`;

export const MediaGridWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  min-height: 140px;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
`;

export const FullScreenImage = styled.img`
  width: 100%;
  max-height: calc(100vh - 200px);
  object-fit: contain;
`;

export const FullScreenVideo = styled.video`
  height: 100%;
  width: 100%;
`;

export const ImageItem = styled.img`
  max-height: 140px;
  max-width: 140px;
`;

export const VideoItem = styled.video`
  max-height: 140px;
  max-width: 140px;
`;

export const SingleMediaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 200px;
`;

export const PlaceholderFlexContainer = styled(Flex)`
  width: 100%;
`;
